import React, { MouseEvent } from "react";
import "./takePicture.scss";
import { DocumentUploadConstants } from "../../constants/shared/documentUploadConstants";
import TakePictureIcon from "../../../assets/icons/take-picture-icon.svg";
import CameraModal from "../CameraModal";
import useModalState from "../../hooks/useModalState";
import { ICapturedFile } from "../CameraComponent";
import Notification from "../Notification";
import { UPLOAD_NOTIFICATION_CONSTANTS } from "../../constants/notification/uploadNotificationConstants";

const { CAMERA_ACCESS_DENIED } = UPLOAD_NOTIFICATION_CONSTANTS;

const { TAKE_PICTURE } = DocumentUploadConstants;

export interface ITakePicture {
  className?: string;
  placeholder?: string;
  onSave?: (capturedFile?: ICapturedFile) => void | undefined;
}

const TakePicture = (props?: ITakePicture) => {
  const { className, placeholder = TAKE_PICTURE, onSave } = props || {};

  const { isModalOpen: isCameraModalOpen, setOpenModal: openCameraModal, setCloseModal: closeCameraModal } = useModalState(false);

  const handleTakePictureClick = async (event?: MouseEvent<HTMLDivElement>) => {
    event?.stopPropagation();

    if (navigator.permissions) {
      const result = await navigator.permissions.query({ name: 'camera' as PermissionName });
      if (result.state === 'granted' || result.state === 'prompt') openCameraModal();
      else Notification(CAMERA_ACCESS_DENIED);
    } else Notification(CAMERA_ACCESS_DENIED);
  };

  return (
    <>
    <div className={`take-picture ${className}`} onClick={handleTakePictureClick}>
      <div className="take-picture__placeholder">
        <img
          src={TakePictureIcon}
          alt="camera-icon"
          className="take-picture__placeholder__image"
        />
        <p>{placeholder}</p>
      </div>
    </div>
    <CameraModal visible={isCameraModalOpen} closeCameraModal={closeCameraModal} onSave={onSave} />
    </>
  );
};

export default TakePicture;
